import { Component, OnInit, ViewChild } from '@angular/core';
import {
  MatPaginator, MatTableDataSource,
  MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSlideToggleModule, MatSnackBar
} from '@angular/material';
import { EditfleetComponent } from "../editfleet/editfleet.component";
import { FleetService } from '../../../services/fleet/fleet.service';
import { ResourceService } from '../../../services/resource/resource.service';
import { TripService } from '../../../services/trip/trip.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import { DataSource } from '@angular/cdk/collections';

@Component({
  selector: 'app-allfleet',
  templateUrl: './allfleet.component.html',
  styleUrls: ['./allfleet.component.scss']
})
export class AllfleetComponent implements OnInit {
  driverArray = [];
  driverData: any;
  selectedDriver: number;
  isDriverSelected: boolean = false;
  driverSelectedForTrip: any;
  driverName: string;
  driverPhoneNo: string;
  driverLicenseNo: string;
  tripID: number;
  fleetResource: number = null;

  columnsToDisplay = [
    'vehicleLicenseNumber',
    'vehicleMake',
    'vehicleModel',
    'capacityDetails',
    'transporter',
    'status',
    'assignDriver',
    'activate',
    'actions'
  ];
  //myDataArray = new MatTableDataSource<FleetListElement>();

  fleetDataArray = new MatTableDataSource;
  @ViewChild(MatPaginator) paginator: MatPaginator;
isLoading: boolean = false;
  constructor(
    public dialog: MatDialog,
    public fleetService: FleetService,
    public resourceService: ResourceService,
    public tripService: TripService,
    public snackBar: MatSnackBar
  ) {
  }

  ngOnInit() {
    //this.myDataArray.paginator = this.paginator;
    this.resourceService.getAllAvailableResources().subscribe(res => {
      this.driverData = res;
      for (let i = 0; i < res.length; i++) {
  
        this.driverArray.push({
          driverName: res[i].firstName + " " + res[i].lastName,
          resourceId: res[i].resourceId
        });
      }
    });

    this.getAllFleets();

  }


  driverSelected(fleet, id) {
    console.log(id);
    console.log("fleet" + fleet);

    let data = {
      resources: id
    }

    console.log(data);

    this.resourceService.getResourceById(data).subscribe(resource => {
      console.log(resource);
      //fleet.preferedDriver = resource;
      console.log(fleet);
      this.fleetService.assignPreferredDriverToFleet(fleet.vehicleLicenseNumber, resource).subscribe(res => {
        console.log(res);
      }, Error => {
        console.log(Error);
      })
    });
  }

  onChange(Event, licenseNumber) {
    console.log(Event.checked);
    if (Event.checked) {
      this.fleetService.ActivateFleet(licenseNumber, true).subscribe(res => {
        console.log(res);
      }, Error => {
        console.log(Error);
      });
    } else {
      this.fleetService.ActivateFleet(licenseNumber, false).subscribe(res => {
        console.log(res);
      }, Error => {
        console.log(Error);
      });
    }
  }

  getAllFleets() {
this.isLoading = true;
this.fleetDataArray.data = [];
    this.fleetService.getallFleets().subscribe(res => {
      console.log(res);
      this.isLoading = false;
      this.fleetDataArray.data = res;
      this.fleetDataArray.paginator = this.paginator;
    }, Error => {
      this.isLoading = false;
      console.log(Error);
    });
  }
  editFleet(vehicleLicenseNumber) {
    let editDialog = this.dialog.open(EditfleetComponent, {
      width: '800px',
      data: {
        licenseNumber: vehicleLicenseNumber
      }
    });
    editDialog.updatePosition({
      top: '50px', right: '0px',
    });
    editDialog.afterClosed().subscribe(result => {
      this.openSnackBar('Fleet Changes Saved Successfully');
    });
  }
  openSnackBar(message) {
    this.snackBar.open(message, 'X', {
      duration: 10000,
      panelClass: ['extraClasses']
    })
  }

  applyFilter(filterValue: string) {
    this.fleetDataArray.filter = filterValue.trim().toLowerCase();
  }
}

export interface FleetListElement {
  vehicleLicenseNumber: string,
  vehicleMake: string,
  vehicleModel: string,
  carryingType: string,
  bodyVolumetricCapacity: string,
  bodyWeightCapacity: string,
  transporter: string,
  activate: any,
  status: string,
  preferedDriver: string
}

export class FleetDataSource extends DataSource<any>{
  constructor(private fleetService: FleetService) {
    super();
  }

  connect(): Observable<FleetListElement[]> {
    return this.fleetService.getallFleets();
  }

  disconnect() { }
}